
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, setDoc, collection, addDoc, query, orderBy, limit, getDocs } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { VisitorLog } from "./types";

const firebaseConfig = {
  apiKey: "AIzaSyDtCVIGhKea7uVAz8aQWeBHh6ufS3SpJxo",
  authDomain: "tes-koneksi-firebase.firebaseapp.com",
  projectId: "tes-koneksi-firebase",
  storageBucket: "tes-koneksi-firebase.firebasestorage.app",
  messagingSenderId: "1062296392303",
  appId: "1:1062296392303:web:2e8bd0627c29b0b021339a"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

const DOC_ID = "content";
const COLLECTION_ID = "bisabikin_id";
const ANALYTICS_COLLECTION = "visitor_logs";

export const saveAppData = async (data: any) => {
  try {
    await setDoc(doc(db, COLLECTION_ID, DOC_ID), data);
    return true;
  } catch (e) {
    console.error("Error saving document: ", e);
    return false;
  }
};

export const getAppData = async () => {
  try {
    const docSnap = await getDoc(doc(db, COLLECTION_ID, DOC_ID));
    if (docSnap.exists()) {
      return docSnap.data();
    }
    return null;
  } catch (e) {
    console.error("Error getting document: ", e);
    return null;
  }
};

export const logVisitor = async (pageName: string = "Landing") => {
  try {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    if (ua.indexOf("Firefox") > -1) browser = "Firefox";
    else if (ua.indexOf("SamsungBrowser") > -1) browser = "Samsung Internet";
    else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) browser = "Opera";
    else if (ua.indexOf("Trident") > -1) browser = "Internet Explorer";
    else if (ua.indexOf("Edge") > -1) browser = "Edge";
    else if (ua.indexOf("Chrome") > -1) browser = "Chrome";
    else if (ua.indexOf("Safari") > -1) browser = "Safari";

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    const deviceType = isMobile ? 'Mobile' : 'Desktop';

    await addDoc(collection(db, ANALYTICS_COLLECTION), {
      timestamp: new Date().toISOString(),
      userAgent: ua,
      browser: browser,
      deviceType: deviceType,
      pageViewed: pageName
    });
  } catch (e) {
    console.error("Error logging visit", e);
  }
};

export const getVisitorStats = async (limitCount = 100): Promise<any[]> => {
  try {
    const q = query(
      collection(db, ANALYTICS_COLLECTION),
      orderBy("timestamp", "desc"),
      limit(limitCount)
    );
    
    const querySnapshot = await getDocs(q);
    const logs: any[] = [];
    querySnapshot.forEach((doc) => {
      logs.push({ id: doc.id, ...doc.data() });
    });
    return logs;
  } catch (e) {
    console.error("Error fetching stats", e);
    return [];
  }
};

export { signInWithEmailAndPassword, signOut, onAuthStateChanged };
